const {
  DISCOUNT_TYPE,
  STOCK_SLIP_STATUS,
  JOB_TITLE,
  STOCK_HISTORY,
  ORDER_STATUS,
  ACTIVE_STATUS_COMMON,
  REWARD_CHECK_TYPE,
  STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE,
  STOCK_CHECK_SHEET_STATUS,
  DEAL_SHEET_PROGRAM_TYPE,
  DEAL_SHEET_TARGET_TYPE,
  DEAL_SHEET_PRIORITY,
  WARRANTY_RECEPTION_STATUS,
  WARRANTY_OUTSOURCE_STATUS,
  WARRANTY_TRANSFER_STATUS,
  HISTORY_ACTION_TYPE,
  IMEI_ACTIVE_STATUS,
  TRANSACTION_TYPE,
  REWARD_CATEGORY_TYPE,
  BILL_TYPE,
  VTP_PAYMENT_METHOD,
  NT_PAYMENT_METHOD,
  BILL_MODE,
  EXCHANGE_REASON,
} = require('./enum')

export const ORDER_STATUS_NAME = Object.freeze({
  [ORDER_STATUS.NEW]: 'Mới',
  [ORDER_STATUS.CONFIRMING]: 'Đang xử lí',
  [ORDER_STATUS.CONFIRMED]: 'Đã xác nhận',
  [ORDER_STATUS.DELIVERY]: 'Đang giao',
  [ORDER_STATUS.PACKING]: 'Đang đóng gói',
  [ORDER_STATUS.SUCCESS]: 'Thành công',
  [ORDER_STATUS.UN_SUCCESS]: 'Không thành công',
  [ORDER_STATUS.SYSTEM_CANCEL]: 'Hệ thống hủy',
  [ORDER_STATUS.REFUNDED]: 'Đã chuyển hoàn',
  [ORDER_STATUS.NO_CATCHED_PHONE]: 'Không bắt máy',
  [ORDER_STATUS.CR_CANCEL]: 'CR hủy',
  [ORDER_STATUS.DEPOSIT]: 'Đã đặt cọc',
  [ORDER_STATUS.AGREE_DEPOSIT]: 'Đồng ý cọc',
  [ORDER_STATUS.PREPARED]: 'Đã chuẩn bị',
  [ORDER_STATUS.TRACKING]: 'Đang theo dõi',
  [ORDER_STATUS.CUSTOMER_CANCEL]: 'Khách hủy',
  [ORDER_STATUS.KEEP_DEPOSIT]: 'Giữ cọc',
  [ORDER_STATUS.RETURNING]: 'Đang chuyển hoàn',
  [ORDER_STATUS.DELIVERY_RECALL]: 'Chờ thu hồi',
  [ORDER_STATUS.DELIVERY_FAILED]: 'Giao thất bại',
})

export function getOrderStatusLabel(status, statusName) {
  return statusName || ORDER_STATUS_NAME[status] || '';
}

export const ORDER_STATUS_BADGE_CONFIG = Object.freeze({
  [ORDER_STATUS.NEW]: {
    variant: 'warning',
    badgeClass: 'badge badge-warning text-white',
  },
  [ORDER_STATUS.CONFIRMING]: {
    variant: 'light',
    badgeClass: 'badge badge-light',
  },
  [ORDER_STATUS.CONFIRMED]: {
    variant: 'primary',
    badgeClass: 'badge badge-primary text-white',
  },
  [ORDER_STATUS.AGREE_DEPOSIT]: {
    variant: 'primary',
    badgeClass: 'badge badge-dark-blue text-white',
  },
  [ORDER_STATUS.DELIVERY]: {
    variant: 'warning',
    badgeClass: 'badge badge-warning text-white',
  },
  [ORDER_STATUS.TRACKING]: {
    variant: 'info',
    badgeClass: 'badge badge-info text-white',
  },
  [ORDER_STATUS.PACKING]: {
    variant: 'info',
    badgeClass: 'badge badge-info text-white',
  },
  [ORDER_STATUS.SUCCESS]: {
    variant: 'success',
    badgeClass: 'badge badge-success text-white',
  },
  [ORDER_STATUS.RETURNING]: {
    variant: 'warning',
    badgeClass: 'badge badge-warning text-dark',
  },
  [ORDER_STATUS.DELIVERY_RECALL]: {
    variant: 'warning',
    badgeClass: 'badge badge-warning text-dark',
  },
  [ORDER_STATUS.DELIVERY_FAILED]: {
    variant: 'dark',
    badgeClass: 'badge badge-dark text-white',
  },
  [ORDER_STATUS.UN_SUCCESS]: {
    variant: 'dark',
    badgeClass: 'badge badge-dark text-white',
  },
  [ORDER_STATUS.SYSTEM_CANCEL]: {
    variant: 'dark',
    badgeClass: 'badge badge-dark text-white',
  },
  [ORDER_STATUS.CR_CANCEL]: {
    variant: 'dark',
    badgeClass: 'badge badge-dark text-white',
  },
  [ORDER_STATUS.CUSTOMER_CANCEL]: {
    variant: 'dark',
    badgeClass: 'badge badge-dark text-white',
  },
  [ORDER_STATUS.KEEP_DEPOSIT]: {
    variant: 'secondary',
    badgeClass: 'badge badge-secondary text-white',
  },
  [ORDER_STATUS.REFUNDED]: {
    variant: 'danger',
    badgeClass: 'badge badge-danger text-white',
  },
  [ORDER_STATUS.DEPOSIT]: {
    variant: 'danger',
    badgeClass: 'badge badge-danger text-white',
  },
  [ORDER_STATUS.NO_CATCHED_PHONE]: {
    variant: 'secondary',
    badgeClass: 'badge badge-secondary text-white',
  },
  [ORDER_STATUS.PREPARED]: {
    variant: 'danger',
    badgeClass: 'badge badge-danger text-dark',
  },
})

export function getOrderStatusVariant(status) {
  return ORDER_STATUS_BADGE_CONFIG[status]?.variant || 'secondary'
}

export function getOrderStatusBadgeClass(status) {
  return ORDER_STATUS_BADGE_CONFIG[status]?.badgeClass || 'badge badge-secondary'
}

export const DISCOUNT_TYPE_NAME = Object.freeze({
  [DISCOUNT_TYPE.Money]: 'Tiền mặt',
  [DISCOUNT_TYPE.Percentage]: 'Phần trăm',
})

export const STOCK_SLIP_STATUS_NAME = Object.freeze({
  [STOCK_SLIP_STATUS.NEW]: 'Mới',
  [STOCK_SLIP_STATUS.APPROVED]: 'Đã duyệt',
  [STOCK_SLIP_STATUS.CONFIRMED]: 'Đã xác nhận',
  [STOCK_SLIP_STATUS.CANCELD]: 'Đã huỷ',
})

export const JOB_TITLE_NAME = Object.freeze({
  [JOB_TITLE.GD]: 'Giám đốc',
  [JOB_TITLE.QL]: 'Quản lý cửa hàng',
  [JOB_TITLE.KTBH]: 'Kế toán bán hàng',
  [JOB_TITLE.TDKH]: 'Tiếp đón khách hàng',
  [JOB_TITLE.KTPC]: 'Kỹ thuật phần cứng',
  [JOB_TITLE.KTNB]: 'Kế toán nội bộ',
  [JOB_TITLE.MKT]: 'Nhân viên marketing',
  [JOB_TITLE.TRADE_MKT]: 'Trade marketing',
  [JOB_TITLE.TVBH]: 'Tư vấn bán hàng',
  [JOB_TITLE.CM]: 'Content media',
  [JOB_TITLE.DPK]: 'Điều phối kho',
  [JOB_TITLE.GDTTBH]: 'Giám đốc trung tâm bảo hành',
  [JOB_TITLE.HTQL]: 'Hỗ trợ quản lý',
  [JOB_TITLE.HVTNCR]: 'HV Trưởng nhóm CR',
  [JOB_TITLE.KTT]: 'Kế toán trưởng',
  [JOB_TITLE.KDOL]: 'Kinh doanh online',
  [JOB_TITLE.NHPK]: 'Ngành hàng Phụ kiện',
  [JOB_TITLE.NSTH]: 'Nhân sự tổng hợp',
  [JOB_TITLE.NVGN]: 'Nhân viên giao nhận',
  [JOB_TITLE.NVKDB2B]: 'Nhân viên kinh doanh B2B',
  [JOB_TITLE.NVKDTT]: 'Nhân viên kinh doanh thị trường',
  [JOB_TITLE.NVT]: 'Nhân viên Tester',
  [JOB_TITLE.PC]: 'Pháp chế',
  [JOB_TITLE.PGD]: 'Phó Giám đốc',
  [JOB_TITLE.QLK]: 'Quản lý kho',
  [JOB_TITLE.TLKD]: 'Trợ lý kinh doanh',
  [JOB_TITLE.TCKTBH]: 'Trưởng ca Kế toán bán hàng',
  [JOB_TITLE.TCKTPM]: 'Trưởng ca Kỹ thuật phần mềm',
  [JOB_TITLE.TCTVBH]: 'Trưởng ca Tư vấn bán hàng',
  [JOB_TITLE.TNHAD]: 'Trưởng Ngành Hàng Android',
  [JOB_TITLE.TNCR]: 'Trưởng nhóm CR',
  [JOB_TITLE.TPKD]: 'Trưởng Phòng Kinh Doanh',
  [JOB_TITLE.TPKDB2B]: 'Trưởng Phòng Kinh Doanh B2B',
  [JOB_TITLE.TPPTNNL]: 'Trưởng Phòng Phát Triển Nguồn Nhân Lực',
  [JOB_TITLE.TVBHDN]: 'Tư vấn bán hàng đa nhiệm',
})

export const STOCK_HISTORY_NAME = Object.freeze({
  [STOCK_HISTORY.IMPORT_STOCK]: 'Nhập kho',
  [STOCK_HISTORY.EXPORT_STOCK]: 'Xuất kho',
  [STOCK_HISTORY.TRANSFER_STOCK]: 'Chuyển kho',
  [STOCK_HISTORY.UPDATE_IMPORT_STOCK]: 'Cập nhật phiếu nhập kho',
  [STOCK_HISTORY.UPDATE_EXPORT_STOCK]: 'Cập nhật phiếu xuất kho',
  [STOCK_HISTORY.EXPORT_TO_TRANSFER]: 'Xuất chuyển kho',
  [STOCK_HISTORY.IMPORT_FROM_TRANSFER]: 'Nhập chuyển kho',
  [STOCK_HISTORY.EXPORT_TO_SALE_RETAIL]: 'Xuất kho bán lẻ',
  [STOCK_HISTORY.EXPORT_TO_SALE_WHOLE_SASE]: 'Xuất kho bán buôn',
  [STOCK_HISTORY.IMPORT_FROM_RETURN_BILL]: 'Nhập từ phiếu trả hàng',
  [STOCK_HISTORY.IMPORT_FROM_REFUND_ORDER]: 'Nhập từ đơn chuyển hoàn',
  [STOCK_HISTORY.EXPORT_TO_SHIPPING]: 'Xuất kho giao hàng',
  [STOCK_HISTORY.INVENTORY_BALANCE]: 'Cân kho',
  [STOCK_HISTORY.IMPORT_WARRANTY]: 'Nhập kho bảo hành',
  [STOCK_HISTORY.UPDATE_IMPORT_WARRANTY]: 'Cập nhật nhập kho bảo hành',
  [STOCK_HISTORY.EXPORT_WARRANTY]: 'Xuất kho bảo hành',
  [STOCK_HISTORY.UPDATE_EXPORT_WARRANTY]: 'Cập nhật xuất kho bảo hành',
  [STOCK_HISTORY.CHANGE_PRODUCT_IMEI]: 'Đổi sản phẩm',
  [STOCK_HISTORY.REMOVE_FROM_BILL]: 'Xóa sản phẩm trong hóa đơn',
  [STOCK_HISTORY.REMOVE_BILL]: 'Xóa hóa đơn',
  [STOCK_HISTORY.REMOVE_RETURN_BILL]: 'Xóa hóa đơn trả hàng',
  [STOCK_HISTORY.UPDATE_EXPORT_TO_SALE]: 'Cập nhật hóa đơn',
  [STOCK_HISTORY.DELETE_TRANSFER_STOCK]: 'Xóa phiếu chuyển kho',
  [STOCK_HISTORY.DELETE_IMPORT_STOCK]: 'Xóa phiếu nhập',
  [STOCK_HISTORY.DELETE_EXPORT_STOCK]: 'Xóa phiếu xuất',
  [STOCK_HISTORY.IMPORT_FROM_TRADE_IN]: 'Nhập kho thu cũ',
  [STOCK_HISTORY.CANCEL_TRANSFER]: 'Hủy phiếu chuyển',
  [STOCK_HISTORY.IMPORT_HOLDING]: 'Nhập kho giữ hàng',
  [STOCK_HISTORY.UPDATE_IMPORT_HOLDING]: 'Cập nhật nhập kho giữ hàng',
  [STOCK_HISTORY.DELETE_IMPORT_HOLDING]: 'Xóa phiếu nhập kho giữ hàng',
  [STOCK_HISTORY.EXPORT_HOLDING]: 'Xuất trả giữ hàng',
  [STOCK_HISTORY.DELETE_EXPORT_HOLDING]: 'Xóa phiếu xuất trả giữ hàng',
  [STOCK_HISTORY.CANCEL_HOLDING]: 'Hủy phiếu giữ hàng',
  [STOCK_HISTORY.DELETE_IMPORT_WARRANTY]: 'Xoá phiếu nhập bảo hành',
  [STOCK_HISTORY.DELETE_EXPORT_WARRANTY]: 'Xoá phiếu xuất bảo hành',
  [STOCK_HISTORY.DELETE_IMPORT_TRADE_IN]: 'Xoá phiếu nhập thu cũ',
  [STOCK_HISTORY.IMPORT_WARRANTY_FROM_BILL]: 'Nhập kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.EXPORT_WARRANTY_FROM_BILL]: 'Xuất kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.UPDATE_IMPORT_WARRANTY_FROM_BILL]: 'Cập nhật nhập kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.UPDATE_EXPORT_WARRANTY_FROM_BILL]: 'Cập nhật xuất kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.DELETE_IMPORT_WARRANTY_FROM_BILL]: 'Xóa phiếu nhập kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.DELETE_EXPORT_WARRANTY_FROM_BILL]: 'Xóa phiếu xuất kho bảo hành từ hóa đơn',
  [STOCK_HISTORY.EXPORT_STOCK_BY_WARRANTY_BILL]: 'Xuất kho bởi đổi sp từ hóa đơn bảo hành',
  [STOCK_HISTORY.DELETE_REQUIRE_EXPORT_WARRANTY_STOCK]: 'Xóa phiếu yêu cầu xuất nhập kho bảo hành',
  [STOCK_HISTORY.EXPORT_WARRANTY_TO_PROVIDER]: 'Xuất kho trả nhà cung cấp',
  [STOCK_HISTORY.UPDATE_EXPORT_WARRANTY_TO_PROVIDER]: 'Xập nhật xuất kho trả nhà cung cấp',
  [STOCK_HISTORY.DELETE_EXPORT_WARRANTY_TO_PROVIDER]: 'Xoá phiếu xuất kho trả nhà cung cấp',
  [STOCK_HISTORY.IMPORT_STOCK_BY_WARRANTY_COMPLETION]: 'Nhập kho bởi phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.EXPORT_STOCK_BY_WARRANTY_COMPLETION]: 'Xuất kho bởi phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.CREATE_WARRANTY_COMPLETION_SLIP]: 'Tạo phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.DELETE_WARRANTY_COMPLETION_SLIP]: 'Xoá phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.DELETE_IMPORT_STOCK_BY_WARRANTY_COMPLETION]:
    'Xoá phiếu nhập kho bởi phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.DELETE_EXPORT_STOCK_BY_WARRANTY_COMPLETION]:
    'Xoá phiếu xuất kho bởi phiếu hoàn tất bảo hành',
  [STOCK_HISTORY.EXPORT_WARRANTY_STOCK_BY_DELETE_WARRANTY_BILL]:
    'Xuất kho bảo hành bởi xoá hoá đơn bảo hành',
  [STOCK_HISTORY.IMPORT_STOCK_BY_DELETE_WARRANTY_BILL]: 'Nhập kho bởi xoá hoá đơn bảo hành',
  [STOCK_HISTORY.IMPORT_STOCK_BY_DELETE_STORE_WARRANTY_BILL]:
    'Nhập kho bởi xoá hoá đơn bảo hành (lỗi cửa hàng)',
  [STOCK_HISTORY.EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL]:
    'Xuất kho bởi tạo hoá đơn bảo hành (lỗi cửa hàng)',
  [STOCK_HISTORY.DELETE_EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL]:
    'Nhập kho bởi xoá hoá đơn bảo hành (lỗi cửa hàng)',
  [STOCK_HISTORY.EXPORT_LENDING]: 'Nhập kho mượn máy',
  [STOCK_HISTORY.UPDATE_EXPORT_LENDING]: 'Cập nhật phiếu xuất kho cho mượn máy',
  [STOCK_HISTORY.DELETE_EXPORT_LENDING]: 'Xoá phiếu xuất kho cho mượn máy',
  [STOCK_HISTORY.IMPORT_STOCK_LENDING]: 'Nhập kho trả máy',
})

export const DISCOUNT_AMOUNT_TYPE_NAME = Object.freeze({
  [DISCOUNT_TYPE.Money]: '$',
  [DISCOUNT_TYPE.Percentage]: '%',
})

export const ACTIVE_STATUS_COMMON_NAME = Object.freeze({
  [ACTIVE_STATUS_COMMON.ENABLED]: 'Hoạt động',
  [ACTIVE_STATUS_COMMON.DISABLED]: 'Đã ngừng',
})

export const REWARD_CHECK_TYPE_NAME = Object.freeze({
  [REWARD_CHECK_TYPE.CH]: 'Hoa hồng cửa hàng',
  [REWARD_CHECK_TYPE.CR]: 'Hoa hồng CSKH',
})

export const STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE_NAME = Object.freeze({
  [STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE.SCAN_QR_CODE]: 'Scan QR',
  [STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE.MOBILE_MANUAL]: 'Thủ công mobile',
  [STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE.WEB_MANUAL]: 'Thủ công từ web',
})

export const STOCK_CHECK_SHEET_STATUS_NAME = Object.freeze({
  [STOCK_CHECK_SHEET_STATUS.NEW]: 'Mới',
  [STOCK_CHECK_SHEET_STATUS.COMFIRM]: 'Xác nhận',
  [STOCK_CHECK_SHEET_STATUS.DONE]: 'Hoàn thành',
  [STOCK_CHECK_SHEET_STATUS.STOCK_DEBT]: 'Truy thu',
  [STOCK_CHECK_SHEET_STATUS.STOCK_DIFF]: 'Lệch tồn',
})

export const DEAL_SHEET_PROGRAM_TYPE_NAME = Object.freeze({
  [DEAL_SHEET_PROGRAM_TYPE.JBP]: 'JBP',
  [DEAL_SHEET_PROGRAM_TYPE.HOT_SALE]: 'Hot sale',
})

export const DEAL_SHEET_TARGET_TYPE_NAME = Object.freeze({
  [DEAL_SHEET_TARGET_TYPE.SALE_OUT]: 'Bán hàng',
  [DEAL_SHEET_TARGET_TYPE.SALE_IN]: 'Nhập hàng',
})

export const DEAL_SHEET_PRIORITY_NAME = Object.freeze({
  [DEAL_SHEET_PRIORITY.LOW]: 'Thấp',
  [DEAL_SHEET_PRIORITY.MEDIUM]: 'Trung bình',
  [DEAL_SHEET_PRIORITY.HIGH]: 'Cao',
})

export const WARRANTY_RECEPTION_STATUS_NAME = Object.freeze({
  [WARRANTY_RECEPTION_STATUS.RECEIVING]: 'Đang tiếp nhận',
  [WARRANTY_RECEPTION_STATUS.REPAIRING]: 'Đang sửa',
  [WARRANTY_RECEPTION_STATUS.REPAIRED]: 'Đã sửa',
  [WARRANTY_RECEPTION_STATUS.COMPLETED]: 'Hoàn thành',
  [WARRANTY_RECEPTION_STATUS.RETURNED]: 'Đã trả',
  [WARRANTY_RECEPTION_STATUS.REJECTED]: 'Đã từ chối',
})

export const WARRANTY_OUTSOURCE_STATUS_NAME = Object.freeze({
  [WARRANTY_OUTSOURCE_STATUS.SENT]: 'Đã xuất',
  [WARRANTY_OUTSOURCE_STATUS.RECEIVED]: 'Đã nhận về',
})

export const HISTORY_ACTION_TYPE_NAME = Object.freeze({
  [HISTORY_ACTION_TYPE.UPDATE]: 'Cập nhật',
  [HISTORY_ACTION_TYPE.DELETE]: 'Xóa',
  [HISTORY_ACTION_TYPE.CREATE]: 'Tạo mới',
  [HISTORY_ACTION_TYPE.UPDATE_NOTE]: 'Cập nhật ghi chú',
  [HISTORY_ACTION_TYPE.UPDATE_STATUS]: 'Cập nhật trạng thái',
  [HISTORY_ACTION_TYPE.CHANGE_STORE]: 'Chuyển cửa hàng bảo hành',
  [HISTORY_ACTION_TYPE.CONFIRM_CHANGE_STORE]: 'Xác nhận máy chuyển cửa hàng',
})

export const IMEI_ACTIVE_STATUS_NAME = Object.freeze({
  [IMEI_ACTIVE_STATUS.NEW]: 'Mới',
  [IMEI_ACTIVE_STATUS.ACTIVED]: 'Đã kích hoạt',
})

export const TRANSACTION_TYPE_NAME = Object.freeze({
  [TRANSACTION_TYPE.CashOut]: 'Phiếu chi',
  [TRANSACTION_TYPE.CashIn]: 'Phiếu thu',
})

export const REWARD_CATEGORY_TYPE_SHORT_NAME = Object.freeze({
  [REWARD_CATEGORY_TYPE.REVENUE]: 'DT',
  [REWARD_CATEGORY_TYPE.QUANTITY]: 'SL',
})

export const WARRANTY_TRANSFER_STATUS_NAME = Object.freeze({
  [WARRANTY_TRANSFER_STATUS.NONE]: 'Chưa chuyển',
  [WARRANTY_TRANSFER_STATUS.PENDING]: 'Đang chờ nhận',
  [WARRANTY_TRANSFER_STATUS.CONFIRMED]: 'Đã nhận',
})

export const BILL_TYPE_NAME = Object.freeze({
  [BILL_TYPE.RETAIL_INVOICE]: 'Bán lẻ',
  [BILL_TYPE.WHOLESALE_INVOICE]: 'Bán buôn',
  [BILL_TYPE.REFUND_INVOICE]: 'Trả hàng',
  [BILL_TYPE.SHIPPING]: 'Giao hàng',
})

export const VTP_PAYMENT_METHOD_NAME = Object.freeze({
  [VTP_PAYMENT_METHOD.NO_COLLECTION]: 'Không thu hộ',
  [VTP_PAYMENT_METHOD.COLLECT_BOTH]: 'Thu hộ tiền hàng và tiền cước',
  [VTP_PAYMENT_METHOD.COLLECT_GOODS_ONLY]: 'Thu hộ tiền hàng, không thu hộ tiền cước',
  [VTP_PAYMENT_METHOD.COLLECT_SHIPPING_ONLY]: 'Thu hộ tiền cước, không thu hộ tiền hàng',
})

export const NT_PAYMENT_METHOD_NAME = Object.freeze({
  [NT_PAYMENT_METHOD.SENDER_PAY_NOW]: 'Người gửi thanh toán ngay',
  [NT_PAYMENT_METHOD.SENDER_PAY_LATER]: 'Người gửi thanh toán sau',
  [NT_PAYMENT_METHOD.RECEIVER_PAY_NOW]: 'Người nhận thanh toán ngay',
})

export const BILL_MODE_NAME = Object.freeze({
  [BILL_MODE.APP]: 'App',
  [BILL_MODE.SHOPEE]: 'Shopee',
  [BILL_MODE.EXCHANGE]: 'Xuất đổi',
})

export const EXCHANGE_REASON_NAME = Object.freeze({
  [EXCHANGE_REASON.WRONG_PRODUCT_CODE]: 'Xuất sai mã sản phẩm',
  [EXCHANGE_REASON.WRONG_IMEI]: 'Xuất sai mã IMEI',
  [EXCHANGE_REASON.CUSTOMER_EXCHANGE]: 'Khách đổi máy',
})
